import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import axios from "axios";
import './App.css';
import themeFile from "./utils/theme";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme"
import jwtDecode from "jwt-decode";
import Navbar from "./components/layout/Navbar";
import AuthRoute from "./utils/AuthRoute";

// Redux
import { Provider } from "react-redux";
import store from "./redux/store";
import { SET_AUTHENTICATED } from "./redux/types";
import { logoutUser, getUserData } from "./redux/actions/userActions";

// Pages
import home from "./pages/home";
import login from "./pages/login";
import signup from "./pages/signup";
import user from "./pages/user";



const theme = createMuiTheme(themeFile);

axios.defaults.baseURL = "https://us-central1-socialapi-e127d.cloudfunctions.net/api";


const token = localStorage.FBIdToken;
if (token) {
  const decodedToken = jwtDecode(token);
  if (decodedToken.exp * 1000 < Date.now()) {
    store.dispatch(logoutUser())
    window.location.href="/login"
  } else {
    store.dispatch({ type: SET_AUTHENTICATED });
    axios.defaults.headers.common["Authorization"] = token;
    store.dispatch(getUserData());
  }
}

class App extends Component {
  render() {
      return (
        <Fragment>
          <MuiThemeProvider theme={theme}>
            <Provider store={store}>
              <Router>
                <Navbar />
                <div className="container">
                  <Switch>
                    <Route exact path="/" component={home} />
                    <AuthRoute exact path="/login" component={login} />
                    <AuthRoute exact path="/signup" component={signup} />
                    <Route exact path="/users/:handle" component={user} />
                    <Route exact path="/users/:handle/scream/:screamId" component={user} />
                  </Switch>
                </div>
              </Router>
            </Provider>
          </MuiThemeProvider>

          <footer className="footer">
            <div className="container">
                <span><a href="https://github.com/MMthree" target="__blank" className="text-muted">GitHub@MMthree <i className="fab fa-github"></i></a></span>
            </div>
          </footer>
        </Fragment>
        
    );
  }
}

export default App;
